import {
    FETCH_START,
    FETCH_FAIL,
    EXAM_CREATED,
    TIMER_STARTED,
    QUESTION_ANSWERED,
    QUESTION_VIEWED,
    EXAM_REGISTERED
} from './examConstants'
import api from '../../common/services/api'

export const createExam = params => {
    return async dispatch => {
        dispatch({ type: FETCH_START });

        try {
            let response = await api.post('/exam', params);
            // console.log(response);
            dispatch({ type: EXAM_CREATED, payload: response.data.data });
            return true
        } catch (e) {
            handleError(dispatch, e);
            return false
        }
    }
};

export const setAnswer = (question, answer) => {
    const key = Number(question) - 1;
    return dispatch => {
        dispatch({ type: QUESTION_ANSWERED, payload: { key, answer }})
    }
};

export const registerExam = (exam, answers) => {
    return async dispatch => {
        dispatch({ type: FETCH_START });
        try {
            let response = await api.post('/exam/register', answers);
            let result = mapResult(exam, response.data.data, answers);
            dispatch({ type: EXAM_REGISTERED, payload: result });
            return true
        } catch (e) {
            handleError(dispatch, e);
            return false
        }
    }
}

export const markAsViewed = (question) => {
    const key = Number(question) - 1;
    return dispatch => {
        dispatch({ type: QUESTION_VIEWED, payload: key })
    }
};

export const startTimer = () => {
    return dispatch => {
        dispatch({ type: TIMER_STARTED, payload: Date.now() })
    }
};

export const getCities = value => {
    return async dispatch => {
        if(value.length > 2) {
            try {
                const response = await api.get(`/city/${value}`);
                return response.data.data.map(city => ({ label: city.cityState, value: city }))
            } catch (e) {
                return []
            }
        }
    }
}

export const getCourses = value => {
    return async dispatch => {
        if(value.length > 2) {
            try {
                const response = await api.get(`/course/${value}`);
                return response.data.data.map(course => ({ label: course.baseCourseName, value: course }))
            } catch (e) {
                return []
            }
        }
    }
}

const mapResult = (exam, response, answers) => {
    // console.log(exam, response, answers)
    return {
        ...response,
        tipo: exam.tipo,
        curso: answers.curso,
        cidade: answers.cidade,
        questoes: exam.questoes.map((questao, index) => {
            return {
                ...questao,
                ...response.questoes[index],
                index
            }
        })
    }
}

const handleError = (dispatch, error) => {
    dispatch({ type: FETCH_FAIL })
    // console.log(error)
};
